export default __webpack_public_path__ + "8a2aa304d0bd5e41d18643aa787a9dd7.ttf";